import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import PopUp from "../../components/Partials/PopUp";
import Header from "../../components/Partials/Header";
import { getMaestro, getCaso, domain } from "../../assets/js/api";
import fotoPlaceHolder from "../../assets/img/placeholder@2x.jpg";
import { getDoceCasosSections } from "../../assets/js/functions";
import { translate, getCurrentLanguage } from "../../assets/js/functions";


export default function Ficha() {
    const { section_id } = useParams();
    const [maestro, setMaestro] = useState(null);
    const [caso, setCaso] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);



    useEffect(() => {
        const relationSections = getDoceCasosSections();
        const result = relationSections.find(relation => relation.sectionTs == section_id);
        if (result) {
            getMaestro(result.sectionCenso).then((maestroCenso) => {
                setMaestro(maestroCenso);
            });
        }

    }, [section_id]);


    useEffect(() => {
        getCaso(section_id).then((caso) => {
            setCaso(caso);
        });
    }, []);

    const openPopup = () => setIsPopupOpen(true);
    const closePopup = () => setIsPopupOpen(false);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    };

    const translateIfNeeded = (text) => {
        return getCurrentLanguage() === 'eu' ? translate(text) : text;
    };

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header />
                <main id="main" className="is-relative mb-7">

                    <p className="px-6 mb-6">
                        <Link to="/doce-casos/" className="is-inline-flex is-size-7 is-align-items-center has-text-black link-dn">
                            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
                                <g fill="none" fillRule="evenodd">
                                    <path d="M0 0h30v30H0z" />
                                    <path stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M6.25 15h17.5M6.25 15l5 5M6.25 15l5-5" />
                                </g>
                            </svg> {translate("Volver a los Doce Casos")}</Link>
                    </p>
                    {maestro && (
                        <div className="wrapper flow--xl">
                            <div className="columns is-flex-direction-row-reverse is-variable is-8">
                                <div className="column flow--xl">
                                    <div className="flow--2xs">
                                        <h1>{maestro.ref_victim_name + ' ' + maestro.ref_victim_surname}</h1>
                                        <p className="is-size-5">{translate("Ficha del Censo de Maestros/as")}</p>
                                    </div>
                                    <div className="columns is-desktop is-variable is-6">
                                        <div className="column flow--l">
                                            <details>
                                                <summary>
                                                    <h2 className="has-text-weight-medium is-size-6">{translateIfNeeded("Datos Personales y Profesionales")}</h2>
                                                </summary>
                                                <div className="has-background-white py-4 px-5 flow is-size-7">
                                                    <p>
                                                        {maestro.victim[0].birthplace_municipality ? maestro.victim[0].birthplace_municipality : ""} {" "}
                                                        {maestro.victim[0].birthdate ? formatDate(maestro.victim[0].birthdate) : ""} - {" "}
                                                        {maestro.victim[0].dead_place_municipality ? maestro.victim[0].dead_place_municipality : ""} {" "}
                                                        {maestro.victim[0].dead_date ? formatDate(maestro.victim[0].dead_date) : ""}.
                                                        <br />
                                                        {maestro.personal_situation ? maestro.personal_situation : ""}
                                                    </p>
                                                </div>
                                            </details>
                                            {maestro.event_data.map((event, index) => {
                                              const typesToTranslate = [
                                                'Datos Personales y Profesionales',
                                                'Ficha acusatoria', 
                                                'Sanción inicial', 
                                                'Síntesis de descargos', 
                                                'Revisiones sanciones Junta Superior de Educación',
                                                'Represión política', 
                                                'Disposiciones ministeriales', 
                                                'Trayectoria posterior',
                                                'Fuentes y bibliografía', 
                                                'Documentación',
                                              ];

                                              if(event.event_type && event.description) {
                                                return (
                                                    <details key={index}>
                                                        <summary>
                                                            <h2 className="has-text-weight-medium is-size-6">{typesToTranslate.includes(event.event_type) ? translateIfNeeded(event.event_type) : event.event_type}</h2>
                                                        </summary>
                                                        <div className="has-background-white py-4 px-5 flow is-size-7">
                                                            <p>{event.description}</p>
                                                        </div>
                                                    </details>

                                                )
                                              }
                                            })}

                                        </div>
                                        <div className="column flow--l">
                                            {maestro.political_repression && (
                                                <details>
                                                    <summary>
                                                        <h2 className="has-text-weight-medium is-size-6">{translateIfNeeded("Represión política")}</h2>
                                                    </summary>
                                                    <div className="has-background-white py-4 px-5 flow is-size-7">
                                                        <p>{maestro.political_repression}</p>
                                                    </div>
                                                </details>
                                            )}
                                            {maestro.further_trajectory && (
                                                <details>
                                                    <summary>
                                                        <h2 className="has-text-weight-medium is-size-6">{translateIfNeeded("Trayectoria posterior")}</h2>
                                                    </summary>
                                                    <div className="has-background-white py-4 px-5 flow is-size-7">
                                                        <p>{maestro.further_trajectory}</p>
                                                    </div>
                                                </details>
                                            )}
                                            {(maestro.bibliographic_references_data && maestro.bibliographic_references_data.length > 0) ? (
                                                <details>
                                                    <summary>
                                                        <h2 className="has-text-weight-medium is-size-6">{translateIfNeeded("Fuentes y bibliografía")}</h2>
                                                    </summary>
                                                    <div className="has-background-white py-4 px-5 flow is-size-7">
                                                        <ul>
                                                            {maestro.bibliographic_references_data.map((reference, index) => (
                                                                <li key={index}>
                                                                    {reference.ref_publications_title}
                                                                    {reference.ref_publications_date && reference.ref_publications_date.trim() !== "" && (
                                                                        <span> ({reference.ref_publications_date})</span>
                                                                    )}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </details>
                                            ) : maestro.deprecated_bibliography_do_not_use_unstructured_text ? (
                                                <details>
                                                    <summary>
                                                        <h2 className="has-text-weight-medium is-size-6">{translateIfNeeded("Fuentes y bibliografía")}</h2>
                                                    </summary>
                                                    <div className="has-background-white py-4 px-5 flow is-size-7">
                                                        <p
                                                            dangerouslySetInnerHTML={{ __html: maestro.deprecated_bibliography_do_not_use_unstructured_text }}
                                                        />
                                                    </div>
                                                </details>
                                            ) : null}

                                            {caso && caso.other_images && Array.isArray(caso.other_images) && caso.other_images.length > 0 ? (
                                                <button type="button" className="info-btn" onClick={openPopup}>
                                                    Documentación
                                                </button>
                                            ) : ''}

                                        </div>
                                    </div>
                                </div>
                                <div className="column is-narrow">
                                    {caso && caso.image && Array.isArray(caso.image) && caso.image.length > 0 && caso.image[0].image ? (
                                        <img
                                            loading="lazy"
                                            src={domain + caso.image[0].image}
                                            alt=""
                                            width="252"
                                            height="287"
                                        />
                                    ) : (
                                        <img
                                            loading="lazy"
                                            src={fotoPlaceHolder}
                                            alt=""
                                            width="252"
                                            height="287"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                </main>
                <Footer />
            </div>

            {isPopupOpen && (
                <PopUp
                    isOpen={isPopupOpen}
                    onClose={closePopup}
                    images={caso.other_images}
                />
            )}

        </Layout >
    );
}